<template>
  <div class="digital-lecture-detail-documents-list">
    <h2 class="title">Материалы к лекции</h2>
    <ul class="list">
      <li v-for="material in materials" :key="material.id" class="item">
        <div class="image-wrapper">
          <img :src="iconFor(material.file_type)" alt="Формат документа" />
        </div>

        <div class="info">
          <span class="name"> {{ material.name }}.{{ material.file_type.toLowerCase() }} </span>
          <div class="params">
            <span v-if="material.file_size" class="size">{{ material.file_size }}</span>
            <a v-if="isDesktop" class="download-link" :href="material.file" download>
              <BaseIconSvoi icon="arrow/import-2" size="s" />
              <span>Скачать</span>
            </a>
          </div>
        </div>

        <BaseButtonLink
          v-if="!isDesktop"
          class="download-button"
          :link="material.file"
          component-type="a"
          icon-right="arrow/import-2"
          size="l"
          download
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButtonLink } from '~/components/base-ui/buttons'
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import type { DigitalLectureMaterial } from '~/models/digital-lecture'
  import pptxIcon from '~/assets/images/pages/digital-lecture/documents/pptx.svg'
  import excelIcon from '~/assets/images/pages/digital-lecture/documents/excel.svg'
  import pdfIcon from '~/assets/images/pages/digital-lecture/documents/pdf.svg'
  import wordIcon from '~/assets/images/pages/digital-lecture/documents/word.svg'

  defineProps<{
    materials: DigitalLectureMaterial[]
  }>()

  const { isDesktop } = useBreakpoint()

  const DOCUMENT_ICONS: Record<string, string> = {
    PPTX: pptxIcon,
    XLSX: excelIcon,
    PDF: pdfIcon,
  }

  function iconFor(type: string): string {
    return DOCUMENT_ICONS[type] ?? wordIcon
  }
</script>

<style lang="scss" scoped>
  .digital-lecture-detail-documents-list {
    @extend %flex-column;

    gap: 20px;
    padding: 24px;
    border-radius: 24px;
    background-color: $color-default-white;

    @include vp-767 {
      padding: 24px 16px;
    }

    > .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      margin: 0;

      @include vp-767 {
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .list {
      @extend %flex-column;

      gap: 20px;
      padding: 0;
      margin: 0;
      list-style: none;
    }

    > .list > .item {
      display: flex;
      align-items: center;
      gap: 16px;

      > .image-wrapper {
        overflow: hidden;
        width: 40px;
        height: 40px;

        > img {
          width: 100%;
          height: 100%;
        }
      }

      > .info > .name {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
      }

      > .info > .params {
        display: flex;
        gap: 20px;

        > .size {
          font-size: 14px;
          line-height: 22px;
          color: $color-potato-30;
        }

        > .download-link {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          color: $color-kiwi-50;
        }
      }

      > .download-button {
        margin-left: auto;
        background-color: $color-kiwi-50;
      }
    }
  }
</style>
